import * as THREE from "three";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import { SMAAPass } from "three/examples/jsm/postprocessing/SMAAPass";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js";
import { GlitchPass } from "./Passes/GlitchPass";
import { FilmShader } from "./shaders/FilmShader.js";
import { RGBShader } from "./shaders/RGBShader.js";
//import { HappyShader } from "./shaders/HappyShader.js";

exports.Unify = function(unify) {
  this.unify_id = "postEffects";
  // Switch to detect when glitch should be turned on
  unify.addNewAsset("glitchOn", false);
  // ---------------------
  // SMAA
  const smaaPass = new SMAAPass(window.innerWidth, window.innerHeight);

  // ---------------------
  // Bloom
  const unrealBloomPass = new UnrealBloomPass(
    new THREE.Vector2(window.innerWidth / 4, window.innerHeight / 4), // resolution
    0.75, // strength
    0.7, // radius
    0.2 // threshold
  );

  // ---------------------
  // Film Grain
  const filmPass = new ShaderPass(FilmShader);

  // ---------------------
  // Chromatic Aberration
  const rgbShiftPass = new ShaderPass(RGBShader);

  // ---------------------
  // Glitch
  const glitchPass = new GlitchPass();

  // ---------------------
  // Render order
  glitchPass.renderToScreen = true; // last pass must have this propery set

  // main.addRenderPass(filmPass);
  unify.addRenderPass(smaaPass);
  unify.addRenderPass(unrealBloomPass);
  unify.addRenderPass(rgbShiftPass);

  unify.addRenderPass(glitchPass);

  glitchPass.enabled = false;

  //this.update = () => {};

  this.glitch = time => {
    glitchPass.enabled = true;
    setTimeout(function() {
      glitchPass.enabled = false;
      rgbShiftPass.renderToScreen = true;
    }, time);
  };
};
